//Ref. https://reacttraining.com/react-router/web/example/auth-workflow

import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Proptypes from 'prop-types';

function AdminRoute(props) {
  const {
    component: Component,
    appLoaded,
    newIsAdmin = false,
    isAuthenticated = false,
    privateRedirect = '/',
    publicRedirect = '/',
    supervisorRedirect = '/profiles',
    adminRedirect = '/dashboard',
    newUserType = '',
    path = '',
    ...rest
  } = props;

  const unvalidBackofficePaths = [
    '/dashboard',
    '/my-emitted-iaf',
    '/overdue-invoices',
  ];

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated &&
        newIsAdmin &&
        (newUserType === 'SUPER_ADMIN' ||
          newUserType === 'SUPERVISOR' ||
          (newUserType === 'SUPERVISOR_USER' &&
            !unvalidBackofficePaths.some((validPath) =>
              path.startsWith(validPath)
            ))) ? (
          appLoaded ? (
            <Component {...props} />
          ) : (
            ''
          )
        ) : isAuthenticated &&
          ((newIsAdmin && newUserType === '') || newUserType === undefined) ? (
          appLoaded ? (
            <Component {...props} path="/" />
          ) : (
            ''
          )
        ) : (
          <Redirect
            push={false}
            to={{
              pathname:
                isAuthenticated && newIsAdmin
                  ? newUserType === 'SUPER_ADMIN'
                    ? adminRedirect
                    : supervisorRedirect
                  : privateRedirect,
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
}

AdminRoute.propTypes = {
  component: Proptypes.func.isRequired,
  newIsAdmin: Proptypes.bool,
  isAuthenticated: Proptypes.bool,
};

export default AdminRoute;
